import { SettlementPlanDefinitions } from "./SettlementPlanDefinitions";
import ComponentHeader from "components/cms/ComponentHeader";
import ComponentDescription from "components/customs/ComponentDescription";

export class SettlementPlan extends SettlementPlanDefinitions {
    render() {
        const { className, designing } = this.props;
        return (
            <div
                data-schema-id={this.props.id}
                className={[
                    "fa-draggable fa-CardList",
                    designing && "designing",
                    className,
                ]
                    .filter((e) => !!e)
                    .join(" ")}
            >
               {designing && (
                    <ComponentHeader
                        componentEntry={this.props.entry}
                        componentSchemaId={this.props.id as string}
                    />
                )}
                <ComponentDescription
                    node={this.props.schemaNode}
                    entry={this.props.entry}
                />
            </div>
        );
    }
}
